<template>
  <div>
    <ejs-grid :dataSource="groupData" ref="groupGrid" :dataBound='dataBound' height="400">
      <e-columns>
        <e-column type="checkbox" width="50" textAlign="center"></e-column>
        <e-column field="groupId" :visible="false" :isPrimaryKey="true"></e-column>
        <e-column field="groupName" :headerText="$t('Security.group.groupName')" width="120" textAlign="Center"></e-column>
        <e-column field="creator" :headerText="$t('Security.Role.creator')" width="120" textAlign="Center"></e-column>
        <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center"></e-column>
        <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
  export default {
    name: 'AccountGroup',
    data() {
      return {
        selectedGroupIds: [],
        groupData: [],
        selectIndexes: [],
        dateFormat: {
          type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
        },
      };
    },
    mounted() {
    },
    methods: {
      init(selectedGroupIds) {
        this.selectedGroupIds = selectedGroupIds;
      },
      getRoleList() {
        const url = '/lte/ems/group/findGroupList';
        const params = { params: {
          } };
        const That = this;
        this.axios.get(url, params).then(response => {
          const result = response.data;
          result.forEach((item, index) => {
            item.createTime = new Date(item.createTime);
            if (That.selectedGroupIds.indexOf(item.groupId) > -1) {
              this.selectIndexes.push(index);
            }
          });
          That.groupData = result;
        });
      },
      dataBound() {
        this.$refs.groupGrid.selectRows(this.selectIndexes, false);
      },
      getSelectRole() {
        return this.$refs.groupGrid.getSelectedRecords();
      }
    }
  };
</script>
